<template>
        <div>
            <h1 class="font-active text-center">
                {{ setTitle }}
            </h1>
            <NuxtLink v-if="$country.is_india" :to="localePath({ name: 'blog-detail', params: { slug: 'trending-customised-diamond-rings' } })">
                <div class="blog_banner">
                    <picture>
                        <source media="(min-width: 768px)" width="2500" height="760" type="image/webp" srcset="~/assets/blog/blog_banner.webp">
                        <source media="(min-width: 768px)" width="2500" height="760" type="image/jpeg" srcset="~/assets/blog/blog_banner.jpg">

                        <source media="(max-width: 600px)" width="600" height="400" type="image/webp" srcset="~/assets/blog/blog_banner_mobile.webp">
                        <source media="(max-width: 600px)" width="600" height="400" type="image/jpeg" srcset="~/assets/blog/blog_banner_mobile.jpg">
                        <img width="2500" height="760" type="image/jpeg" src="~/assets/blog/blog_banner.jpg" alt="our blog" />
                    </picture>
                    <h2 class="font-active"> What's In: Customised <br> Diamond Rings Edition</h2>
                </div>
            </NuxtLink>
            <NuxtLink :to="localePath({ name: 'blog-detail', params: { slug: 'proposal-with-round-solitaire-engagement-ring' } })" v-else>
                <div class="blog_banner">
                    <picture>
                        <source media="(min-width: 768px)" width="2500" height="760" type="image/webp" srcset="~/assets/blog/blog_banner_us.webp">
                        <source media="(min-width: 768px)" width="2500" height="760" type="image/jpeg" srcset="~/assets/blog/blog_banner_us.jpg">

                        <source media="(max-width: 600px)" width="600" height="400" type="image/webp" srcset="~/assets/blog/blog_banner_mobile_us.webp">
                        <source media="(max-width: 600px)" width="600" height="400" type="image/jpeg" srcset="~/assets/blog/blog_banner_mobile_us.jpg">
                        <img width="2500" height="760" type="image/jpeg" src="~/assets/blog/blog_banner_us.jpg" alt="our blog" class="radious_eight"/>
                    </picture>
                    <h2 class="font-active">Solitaire Magic: Your Ultimate <br> Destination Proposal Guide</h2>
                </div>
            </NuxtLink>
        </div>
</template>

<script setup>
    const route = useRoute()
    const localePath = useLocalePath()
    const { $country,$i18n } = useNuxtApp()

    const setTitle = computed(() => {
        const subType = route.params.sub_type;
        if (subType === 'new-trends') {
            return 'New Trends';
        }
        if (subType === 'gift-ideas') {
            return 'Gift Ideas';
        }
        if (subType === 'diamond-guide') {
            return 'Diamond Guide';
        }
        if (subType === 'all-about-rings') {
            return 'All About Rings';
        }
        if (subType === 'jewelry-guide') {
            return $i18n.t('jewelry') + ' Guide';
        }
        return 'Our Blog';
    });
</script>

<style scoped>
h1 {
    margin:0 0 2% 0;
    font-size: 52px;
    text-transform: capitalize;
}
a{
    color: #000;
    text-decoration: none;
}
a:hover{
    color: #000;
}
.blog_banner{
    position: relative;
}
.blog_banner h2{
    position: absolute;
    bottom: 0;
    left: 0;
    background: none;
    padding: 3% 4%;
    box-sizing: border-box;
    font-size: 32px;
    color: #212529;
    width: 100%;
    text-align: right;
}

@media(max-width: 1250px){
    .blog_banner h2{
        font-size: 26px;
        padding: 3% 5%;
    }

    h1{
        font-size: 32px;
    }

}
@media(max-width: 767px){
    .blog_banner h2 br {
        display: none;
    }
    .blog_banner h2 {
        position: relative;
        font-size: 24px;
        width: 100%;
        color: #000;
        text-align: center;
        padding: 5% 0;
    }
     
}
</style>
